import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import logo from '../assets/images/camdiab-logo.png';
import {footerText as footerText_en} from "../libs/en/texts-footer-lib";
import parse from "html-react-parser";
import {loadLocaleExport} from '../utils/localeLoader';
import {getLanguagePrefix} from '../utils/language';
import {isCamAPSLibertyVisible} from '../utils/countries';

export class Footer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            language: this.props.props.language,
            footerText: footerText_en,
            prefix: getLanguagePrefix(this.props.props.language)
        };
    }

    loadFooterText = async (language) => {
        const footerText = await loadLocaleExport({
            language,
            fileName: 'texts-footer-lib',
            exportName: 'footerText',
            folderOverrides: {'FR-FR': 'fr-fr'},
        });

        if (this.props.props.language === language) {
            this.setState({
                language,
                footerText,
                prefix: getLanguagePrefix(language),
            });
        }
    };

    componentDidMount() {
        this.loadFooterText(this.props.props.language).catch(() => {
        });
    }

    componentDidUpdate() {
        if (this.state.language !== this.props.props.language) {
            this.loadFooterText(this.props.props.language).catch(() => {
            });
        }
    }

    render() {
        return (
            <div>
                <footer className="footer-main">
                    <div className="container">
                        <div className="footer-content">
                            {/* Logo Section */}
                            <div className="footer-logo">
                                <Link to={this.state.prefix + "/"}>
                                    <img src={logo} alt="CamDiab" />
                                </Link>
                            </div>

                            {/* Navigation Section - 4 Columns (single-link columns placed last) */}
                            <div className="footer-nav-section">
                                <div className="footer-nav-column">
                                    <Link to={this.state.prefix + "/support"}>{parse(this.state.footerText.txtSupport)}</Link>
                                    <Link to={this.state.prefix + "/user-training"}>{parse(this.state.footerText.txtUserTraining)}</Link>
                                </div>
                                {!isCamAPSLibertyVisible(this.props.props.language) ? (
                                    <>
                                        <div className="footer-nav-column">
                                            <Link to={this.state.prefix + "/stories"}>{parse(this.state.footerText.txtReviews)}</Link>
                                            <Link to={this.state.prefix + "/notifications"}>{parse(this.state.footerText.txtNotifications)}</Link>
                                        </div>
                                        <div className="footer-nav-column">
                                            <Link to={this.state.prefix + "/press-releases"}>{parse(this.state.footerText.txtNews)}</Link>
                                        </div>
                                        <div className="footer-nav-column">
                                            <Link to={this.state.prefix + "/faq"}>{parse(this.state.footerText.txtFAQs)}</Link>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="footer-nav-column">
                                            <Link to={this.state.prefix + "/press-releases"}>{parse(this.state.footerText.txtNews)}</Link>
                                            <Link to={this.state.prefix + "/liberty"}>{parse(this.state.footerText.txtCamAPSLiberty)}</Link>
                                        </div>
                                        {this.props.props.language === 'EN' ? (
                                            <>
                                                <div className="footer-nav-column">
                                                    <Link to={this.state.prefix + "/faq"}>{parse(this.state.footerText.txtFAQs)}</Link>
                                                    <a href="https://camdiab.com/careers" target="_blank" rel="noopener noreferrer">{parse(this.state.footerText.txtCareers)}</a>
                                                </div>
                                                <div className="footer-nav-column">
                                                    <Link to={this.state.prefix + "/stories"}>{parse(this.state.footerText.txtReviews)}</Link>
                                                    <Link to={this.state.prefix + "/notifications"}>{parse(this.state.footerText.txtNotifications)}</Link>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div className="footer-nav-column">
                                                    <Link to={this.state.prefix + "/stories"}>{parse(this.state.footerText.txtReviews)}</Link>
                                                    <Link to={this.state.prefix + "/notifications"}>{parse(this.state.footerText.txtNotifications)}</Link>
                                                </div>
                                                <div className="footer-nav-column">
                                                    <Link to={this.state.prefix + "/faq"}>{parse(this.state.footerText.txtFAQs)}</Link>
                                                </div>
                                            </>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>

                        {/* Bottom Links Row with Social Media */}
                        <div className="footer-bottom-links">
                            <Link to={this.state.prefix + "/terms"}>{parse(this.state.footerText.terms)}</Link>
                            <Link to={this.state.prefix + "/accessibility"}>{parse(this.state.footerText.accessibility)}</Link>
                            <Link to={this.state.prefix + "/privacy"}>{parse(this.state.footerText.privacy)}</Link>
                            <a href={parse(this.state.footerText.statusPageFooterLink)} target="_blank" rel="noopener noreferrer">
                                {parse(this.state.footerText.statusPageFooterText)}
                            </a>
                            <a href={parse(this.state.footerText.sscpPageFooterHtml)} target="_blank" rel="noopener noreferrer">
                                {parse(this.state.footerText.sscpPageFooterText)}
                            </a>
                            
                            {/* Social Media Icons */}
                            <div className="footer-social">
                                <a href="https://www.instagram.com/camdiab" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
                                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                                    </svg>
                                </a>
                                <a href="https://www.facebook.com/CamAPSFX" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
                                        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                                    </svg>
                                </a>
                                <a href="https://www.linkedin.com/company/camdiab" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
                                        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                                    </svg>
                                </a>
                                <a href="https://twitter.com/CamAPS_FX" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
                                        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                                    </svg>
                                </a>
                            </div>
                        </div>

                        {/* Legal Text */}
                        <div className="footer-legal">
                            <p>{parse(this.state.footerText.txtFooterBottom)}</p>
                        </div>

                  
                    </div>
                          {/* Copyright */}
                          <div className="footer-copyright">
                            <p>&copy; {new Date().getFullYear()} {parse(this.state.footerText.rightsReserved)}</p>
                        </div>
                </footer>
            </div>
        );
    }
}

